export default __webpack_public_path__ + "static/media/earn_active.8bf0a740.svg";